var map = {
	"./ibd_arm1.png": 121,
	"./ibd_arm2.png": 122,
	"./ibd_arm3.png": 123,
	"./ibd_back1.png": 124,
	"./ibd_back2.png": 125,
	"./ibd_back3.png": 126,
	"./ibd_foot1.png": 127,
	"./ibd_foot2.png": 128,
	"./ibd_foot3.png": 129,
	"./ibd_hips1.png": 130,
	"./ibd_hips2.png": 131,
	"./ibd_hips3.png": 132,
	"./ibd_neck1.png": 133,
	"./ibd_neck2.png": 134,
	"./ibd_neck3.png": 135,
	"./ibd_shoulder1.png": 136,
	"./ibd_shoulder2.png": 137,
	"./ibd_shoulder3.png": 138
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;